// removed by extract-text-webpack-plugin
module.exports = {"Container":"Layout__Container__3uijv"};


//////////////////
// WEBPACK FOOTER
// ./src/hoc/Layout/Layout.css
// module id = 125
// module chunks = 0